import ClientPortalDashboardCases from './ClientPortalDashboardCases';

export default ClientPortalDashboardCases;
